/// <reference path="./smartmarkdown.types.d.ts" />

// pushrocks scope
import * as smartyaml from '@push.rocks/smartyaml';

export {
  smartyaml
};

// third party remark
import type { Plugin, Transformer } from 'unified';
import type { Root, RootContent } from 'mdast';
import remarkHtml from 'remark-html';
import remarkStringify from 'remark-stringify';

export { remarkHtml, remarkStringify };
export type { Plugin, Transformer, Root, RootContent };

// other third party stuff
import turndown from 'turndown';
import * as rawTurndownPluginGfm from 'turndown-plugin-gfm';

type TTurndownPlugin = (serviceArg: InstanceType<typeof turndown>) => void;

const turndownPluginGfm = rawTurndownPluginGfm as {
  gfm: TTurndownPlugin;
  strikethrough: TTurndownPlugin;
  tables: TTurndownPlugin;
  taskListItems: TTurndownPlugin;
};

export { turndown, turndownPluginGfm };
